import appPackages from "../../views/appPlans/packages.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "packages";
  const params = ["page", "limit"];

  $stateProvider.state("packages", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appPackages,
      },
    },
    reloadOnSearch: false,
    data: { title: "Packages" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/packages/packages.urls.js